<template>
  <div class="col-md-12">
    <div class="card card-container">
      <h4><font-awesome-icon icon="plus-square" /> Add Member</h4>
      <form name="form" @submit.prevent="saveMember">
        <div v-if="!successful">
          <input v-model="member.rootId" v-validate="'required|min:9|max:12'" type="hidden" id="rootId" name="rootId">
          <div class="form-group">
            <label for="newTreeMemberId">Prospective ID:</label>
            <input v-model="newTree.newTreeMemberId" v-validate="'required|min:9|max:12'" type="text" class="form-control" id="newTreeMemberId" name="newTreeMemberId" readonly="readonly"/>
            <div v-if="submitted && errors.has('newTreeMemberId')" class="alert-danger">{{errors.first('newTreeMemberId')}}</div>
          </div>
          <div class="form-group">
            <label for="surname">Surname:</label>
            <input v-model="member.surname" v-validate="'required|min:3|max:75'" type="text" class="form-control" id="surname" name="surname"/>
            <div v-if="submitted && errors.has('surname')" class="alert-danger" >{{errors.first('surname')}}</div>
          </div>
          <div class="form-group">
            <label for="firstName">First Name:</label>
            <input v-model="member.firstName" v-validate="'required|min:3|max:75'" type="text" class="form-control" id="firstName" name="firstName"/>
            <div v-if="submitted && errors.has('firstName')" class="alert-danger" >{{errors.first('firstName')}}</div>
          </div>
          <div class="form-group">
            <label for="middleName">Middle Name:</label>
            <input v-model="member.middleName" v-validate="'required|min:1|max:75'" type="text" class="form-control" id="middleName" name="middleName"/>
            <div v-if="submitted && errors.has('middleName')" class="alert-danger" >{{errors.first('middleName')}}</div>
          </div>
          <div class="form-group">
            <label for="gender">Gender:</label>
            <select v-model="member.gender" v-validate="'required|min:4|max:6'" class="form-control" id="gender" name="gender">
              <option disabled value="">Please select one</option>
              <option>Female</option>
              <option>Male</option>
            </select>
            <div v-if="submitted && errors.has('gender')" class="alert-danger" >{{errors.first('gender')}}</div>
          </div>
          <div class="form-group">
            <label for="address">Address:</label>
            <input v-model="member.address" v-validate="'required|min:6|max:95'" type="text" class="form-control" id="address" name="address"/>
            <div v-if="submitted && errors.has('address')" class="alert-danger" >{{errors.first('address')}}</div>
          </div>
          <div class="form-group">
            <label for="countries">Country:</label>
            <select v-model="member.country" @change="onChangeCountry($event)" v-validate="'required|min:3|max:75'" class="form-control" id="country" name="country">
              <option disabled value="">Please select one</option>
              <option v-for="country in countries" v-bind:value="country.name" :key="country.name">{{ country.name }}</option>
            </select>
            <div v-if="submitted && errors.has('country')" class="alert-danger">{{errors.first('country')}}</div>
          </div>
          <div class="form-group">
            <label for="states">State:</label>
            <select v-model="member.state" @change="onChangeState($event)" v-validate="'required|min:3|max:75'" class="form-control" id="state" name="state">
              <option v-if="noStates" disabled value="">Please select country first</option>
              <option v-else disabled value="">Please select one</option>
              <option v-for="state in states" v-bind:value="state.name" :key="state.name">{{ state.name }}</option>
            </select>
            <div v-if="submitted && errors.has('state')" class="alert-danger">{{errors.first('state')}}</div>
          </div>
          <div class="form-group">
            <label for="phoneNumber">Phone Number:</label>
            <input v-model="member.phoneNumber" v-validate="'required|min:9|max:16'" type="number" class="form-control" id="phoneNumber" name="phoneNumber"/>
            <div v-if="submitted && errors.has('phoneNumber')" class="alert-danger" >{{errors.first('phoneNumber')}}</div>
          </div>
          <div class="form-group">
            <label for="email">Email:</label>
            <input v-model="member.email" v-validate="'required|min:11|max:75'" type="email" class="form-control" id="name" name="email"/>
            <div v-if="submitted && errors.has('email')" class="alert-danger" >{{errors.first('email')}}</div>
          </div>
          <!-- <div class="form-group">
            <label for="members">Sponsor/Upline:</label>
            <select v-model="member.sponsor" @change="onChangeMember($event)" v-validate="'required|min:9|max:12'" class="form-control" id="sponsor" name="sponsor">
              <option disabled value="">Please select one</option>
              <option v-for="member in members" v-bind:value="member.id" :key="member.id">{{ member.id }} ({{ member.surname }}, {{ member.first_name }})</option>
            </select>
            <div v-if="submitted && errors.has('sponsor')" class="alert-danger">{{errors.first('sponsor')}}</div>
          </div> -->
          <div class="form-group">
            <label for="sponsor">Sponsor/Upline:</label>
            <input v-model="member.sponsor" v-validate="'required|min:9|max:12'" type="number" class="form-control" id="sponsor" name="sponsor"/>
            <div v-if="submitted && errors.has('sponsor')" class="alert-danger" >{{errors.first('sponsor')}}</div>
          </div>
          <div class="form-group">
            <label for="joinedDate">Joined Date:</label>
            <input v-model="member.joinedDate" v-validate="'required|min:10|max:10'" type="date" class="form-control" id="joinedDate" name="joinedDate"/>
            <div v-if="submitted && errors.has('joinedDate')" class="alert-danger" >{{errors.first('joinedDate')}}</div>
          </div>
          <div class="form-group">
            <label for="bank">Bank:</label>
            <select v-model="member.bank" v-validate="'required|min:3|max:75'" class="form-control" id="bank" name="bank">
              <option disabled value="">Please select one</option>
              <option>Access Bank</option>
              <option>Citibank</option>
              <option>Ecobank</option>
              <option>Fidelity Bank</option>
              <option>First Bank</option>
              <option>First City Monument Bank (FCMB)</option>
              <option>FSDH Merchant Bank</option>
              <option>Guarantee Trust Bank (GTB)</option>
              <option>Heritage Bank</option>
              <option>Keystone Bank</option>
              <option>Rand Merchant Bank</option>
              <option>Polaris Bank</option>
              <option>Stanbic IBTC Bank</option>
              <option>Standard Chartered Bank</option>
              <option>Sterling Bank</option>
              <option>Suntrust Bank</option>
              <option>Union Bank</option>
              <option>United Bank for Africa (UBA)</option>
              <option>Unity Bank</option>
              <option>Wema Bank</option>
              <option>Zenith Bank</option>
            </select>
            <div v-if="submitted && errors.has('bank')" class="alert-danger" >{{errors.first('bank')}}</div>
          </div>
          <div class="form-group">
            <label for="accountNumber">Account Number:</label>
            <input v-model="member.accountNumber" v-validate="'required|min:10|max:10'" type="number" class="form-control" id="accountNumber" name="accountNumber"/>
            <div v-if="submitted && errors.has('accountNumber')" class="alert-danger" >{{errors.first('accountNumber')}}</div>
          </div>
          <div class="form-group">
            <label for="accountName">Account Name:</label>
            <input v-model="member.accountName" v-validate="'required|min:3|max:75'" type="text" class="form-control" id="accountName" name="accountName"/>
            <div v-if="submitted && errors.has('accountName')" class="alert-danger" >{{errors.first('accountName')}}</div>
          </div>
          <div class="form-group">
            <button type="submit" class="m-3 btn btn-sm btn-success"><font-awesome-icon icon="save" /> Save</button>
            <button class="m-3 btn btn-sm btn-primary" @click="membersList"><font-awesome-icon icon="arrow-alt-circle-left" /> Back</button>
          </div>
        </div>
      </form>

      <div v-if="message" class="alert" :class="successful ? 'alert-success' : 'alert-danger'">
        {{message}}
      </div>
      <div v-if="message && successful">
        <button class="btn btn-primary" @click="newMember"><font-awesome-icon icon="plus" /> Add Member</button>
      </div>
    </div>
  </div>
</template>

<script>
import MemberService from "../services/member.service";
import CountryService from "../services/country.service";
import StateService from "../services/state.service";
//import UserService from "../services/user.service";
//import User from '../models/user';

export default {
  name: 'add-member',
  data() {
    return {
      member: {
        id: null,
        networkMemberId: 0,
        surname: '',
        firstName: '',
        middleName: '',
        gender: '',
        address: '',
        country: '',
        state: '',
        dateOfBirth: '',
        phoneNumber: '',
        email: '',
        sponsor: '',
        level: 1,
        upline: '',
        joinedDate: '',
        idCardType: '',
        idCardNumber: '',
        photoUrl: '',
        bank: '',
        accountNumber: '',
        accountName: '',
        rootId: 234500000
      },
      newTree: {
        newTreeMemberId: 0
      },
      submitted: false,
      successful: false,
      message: '',
      frontlineCount: 0,
      noStates: true,
      countries: [],
      states: [],
      members: [],
      //user: new User('', '', '', '', '', '', ''),
    };
  },
  computed: {
    loggedIn() {
      return this.$store.state.auth.status.loggedIn;
    }
  },
  methods: {
    retrieveCountries() {
      CountryService.getAll()
        .then(response => {
          this.countries = response.data;
          //console.log(response.data);
        })
        .catch(e => {
          console.log(e);
        });
    },

    onChangeCountry: function(e) {
      this.member.country = e.target.value;
      this.retrieveStatesByCountry();
    },

    retrieveStatesByCountry() {
      StateService.getStatesByCountry(this.member.country)
        .then(response => {
          this.states = response.data;
          //console.log(response.data);
          if(this.states.length > 0){ 
            this.noStates = false;
          }
          else{
            this.noStates = true;
          }
        })
        .catch(e => {
          console.log(e);
        });
    },

    onChangeState: function(e) {
      this.member.state = e.target.value;
    },

    retrieveMembers() {
      MemberService.getAll()
        .then(response => {
          this.members = response.data;
          //console.log(response.data);
        })
        .catch(e => {
          console.log(e);
        });
    },

    getLastRow() {
      MemberService.getLastRow()
        .then(response => {
          this.newTree.newTreeMemberId = response.data + 1;
          //console.log(response.data);
        })
        .catch(e => {
          console.log(e);
        });
    },

    getFrontLinersCountBySponsor() {
      MemberService.getFrontLinersCountBySponsor(this.member.sponsor)
        .then(response => {
          this.frontlineCount = response.data;
          //console.log(response.data);
        })
        .catch(e => {
          console.log(e);
        });
    },

     onChangeMember: function(e) {
      this.member.sponsor = e.target.value;
      this.getFrontLinersCountBySponsor();
      //console.log('this.member.sponsor: '+this.member.sponsor);
    },

    /*saveMember() {
      if(this.frontlineCount > 6){
        this.message = 'Sponsor/Upline already has complete Legs. Cannot sponsor member!';
        this.successful = false;
      }
      else{
        this.member.networkMemberId = this.newTree.newTreeMemberId;

        this.user.staffNo = this.member.firstName;
        this.user.firstName = this.member.firstName;
        this.user.lastName = this.member.surname;
        this.user.username = this.member.networkMemberId;
        this.user.email = this.member.email;
        this.user.password = 'edibleherbs';
        this.user.userType = 'User';

        var memberData = {
          id: this.member.networkMemberId,
          networkMemberId: this.member.networkMemberId,
          surname: this.member.surname,
          firstName: this.member.firstName,
          middleName: this.member.middleName,
          gender: this.member.gender,
          address: this.member.address,
          country: this.member.country,
          state: this.member.state,
          dateOfBirth: this.member.dateOfBirth,
          phoneNumber: this.member.phoneNumber,
          email: this.member.email,
          sponsor: this.member.sponsor,
          level: this.member.level,
          upline: this.member.sponsor,
          joinedDate: this.member.joinedDate,
          idCardType: this.member.idCardType,
          idCardNumber: this.member.idCardNumber,
          photoUrl: this.member.photoUrl,
          bank: this.member.bank,
          accountNumber: this.member.accountNumber,
          accountName: this.member.accountName,
          rootId: this.member.rootId
        };
        this.message = '';
        this.submitted = true;
        this.$validator.validate().then(isValid => {
        if (isValid) {
          UserService.create(this.user).then(
            response => {
              //this.message = response.data.message;
              console.log('data message: '+response.data.message);
              MemberService.create(memberData).then(
                response => {
                  this.message = 'The member was created successfully!';
                  this.member.id = response.data.id;
                  //console.log('data: '+response.data);
                  this.submitted = true;
                  this.successful = true;
                },
                error => {
                  this.message = (error.response && error.response.data) || error.message || error.toString();
                  this.successful = false;
                })
                .catch(e => {
                  console.log('e: '+e);
                  this.message = e.message;
                  console.log('e message: '+e.message);
                });

            },
            error => {
              this.message = (error.response && error.response.data) || error.message || error.toString();
              this.successful = false;
            })
            .catch(e => {
              console.log('e: '+e);
              this.message = e.message;
              console.log('e message: '+e.message);
            });
          
        }
      });

      }
    },*/

    /*saveMember() {
      if(this.frontlineCount > 6){
        this.message = 'Sponsor/Upline already has complete Legs. Cannot sponsor member!';
        this.successful = false;
      }
      else{
        this.member.networkMemberId = this.newTree.newTreeMemberId;

        var memberData = {
          id: this.member.networkMemberId,
          networkMemberId: this.member.networkMemberId,
          surname: this.member.surname,
          firstName: this.member.firstName,
          middleName: this.member.middleName,
          gender: this.member.gender,
          address: this.member.address,
          country: this.member.country,
          state: this.member.state,
          dateOfBirth: this.member.dateOfBirth,
          phoneNumber: this.member.phoneNumber,
          email: this.member.email,
          sponsor: this.member.sponsor,
          level: this.member.level,
          upline: this.member.sponsor,
          joinedDate: this.member.joinedDate,
          idCardType: this.member.idCardType,
          idCardNumber: this.member.idCardNumber,
          photoUrl: this.member.photoUrl,
          bank: this.member.bank,
          accountNumber: this.member.accountNumber,
          accountName: this.member.accountName,
          rootId: this.member.rootId
        };
        this.message = '';
        this.submitted = true;
        this.$validator.validate().then(isValid => {
        if (isValid) {
          MemberService.create(memberData).then(
            response => {
              this.message = response.data.message;
              this.submitted = true;
              this.successful = true;
            },
            error => {
              this.message = (error.response && error.response.data) || error.message || error.toString();
              this.successful = false;
            })
            .catch(e => {
              console.log('e: '+e);
              this.message = e.message;
              console.log('e message: '+e.message);
            });
          
        }
      });

      }
    },*/

    saveMember() {
      MemberService.memberExist(this.member.sponsor)
        .then(response => {
          let sponsorExistRes = response.data;
          //console.log(response.data);
          if(sponsorExistRes <= 0){
            this.message = 'Invalid Sponsor/Upline!';
            this.successful = false;
          }
          else if(this.member.sponsor >= this.newTree.newTreeMemberId){
            this.message = 'Error: '+this.member.sponsor+' cannot sponsor '+this.newTree.newTreeMemberId+'!';
            this.successful = false;
          }
          else{ 
            this.getFrontLinersCountBySponsor();

            if(this.frontlineCount > 6){
              this.message = 'Sponsor/Upline already has complete Legs. Cannot sponsor member!';
              this.successful = false;
            }
            else{
              this.member.networkMemberId = this.newTree.newTreeMemberId;

              var memberData = {
                id: this.member.networkMemberId,
                networkMemberId: this.member.networkMemberId,
                surname: this.member.surname,
                firstName: this.member.firstName,
                middleName: this.member.middleName,
                gender: this.member.gender,
                address: this.member.address,
                country: this.member.country,
                state: this.member.state,
                dateOfBirth: this.member.dateOfBirth,
                phoneNumber: this.member.phoneNumber,
                email: this.member.email,
                sponsor: this.member.sponsor,
                level: this.member.level,
                upline: this.member.sponsor,
                joinedDate: this.member.joinedDate,
                idCardType: this.member.idCardType,
                idCardNumber: this.member.idCardNumber,
                photoUrl: this.member.photoUrl,
                bank: this.member.bank,
                accountNumber: this.member.accountNumber,
                accountName: this.member.accountName,
                rootId: this.member.rootId
              };
              this.message = '';
              this.submitted = true;

              this.$validator.validate().then(isValid => {
                if (isValid) {
                  MemberService.create(memberData).then(
                    response => {
                      this.message = response.data.message;
                      this.submitted = true;
                      this.successful = true;
                    },
                    error => {
                      this.message = (error.response && error.response.data) || error.message || error.toString();
                      this.successful = false;
                    })
                    .catch(e => {
                      console.log('e: '+e);
                      this.message = e.message;
                      console.log('e message: '+e.message);
                    });
                }
          
              });

            }

          }

        })
        .catch(e => {
          console.log(e);
        });

    },

    newMember() {
      this.submitted = false;
      this.successful = false;
      this.message = '';
      this.member = {};
      this.member.level = 1;
      this.member.rootId = 234500000;
      //this.user = new User('', '', '', '', '', '', '');
      this.frontlineCount = 0;
      this.noStates = true;
      this.getLastRow();
      this.retrieveMembers();
    },
    
    membersList() {
      this.$router.push('/members');
    }
  },

  mounted() {
    this.retrieveCountries();
    //this.retrieveMembers();
    this.getLastRow();
  }
};
</script>

<style scoped>
label {
  display: block;
  margin-top: 10px;
  font-size: 1.2em;
  text-align: left;
}

.card-container.card {
  max-width: 750px !important;
  padding: 40px 40px;
}

.card {
  background-color: #f7f7f7;
  padding: 20px 25px 30px;
  margin: 0 auto 25px;
  margin-top: 50px;
  -moz-border-radius: 2px;
  -webkit-border-radius: 2px;
  border-radius: 2px;
  -moz-box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);
  -webkit-box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);
  box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);
}

.profile-img-card {
  width: 96px;
  height: 96px;
  margin: 0 auto 10px;
  display: block;
  -moz-border-radius: 50%;
  -webkit-border-radius: 50%;
  border-radius: 50%;
}
</style>